export const DEFAULT_DC_CABLE_LENGTH_MPPT_METERS = 15
export const DEFAULT_DC_CABLE_LENGTH_METERS_PER_STRING_PANEL = 2

export type DCCableLengthAttachObject = {
  type?: string
  moduleQuantity?: () => number
  modules?: unknown[]
  strings?: () => DCCableLengthAttachObject[]
}

export function getStringPanelCount(attachObject?: DCCableLengthAttachObject): number {
  if (!attachObject) return 0
  return attachObject.moduleQuantity?.() ?? attachObject.modules?.length ?? 0
}

export function attachObjectHasStrungModules(attachObject?: DCCableLengthAttachObject | null): boolean {
  if (!attachObject) return false
  if (attachObject.type === 'OsString') return getStringPanelCount(attachObject) > 0
  if (attachObject.type === 'OsMppt') {
    return attachObject.strings?.().some((string) => getStringPanelCount(string) > 0) ?? false
  }
  return false
}

export const getDefaultDCCableLengthMeters = (attachObject?: DCCableLengthAttachObject): number => {
  const objectType = attachObject?.type
  if (objectType === 'OsMppt') return DEFAULT_DC_CABLE_LENGTH_MPPT_METERS
  if (objectType === 'OsString') {
    const panelCount = getStringPanelCount(attachObject)
    return panelCount > 0 ? panelCount * DEFAULT_DC_CABLE_LENGTH_METERS_PER_STRING_PANEL : 0
  }
  return DEFAULT_DC_CABLE_LENGTH_MPPT_METERS
}

export const getConfiguredOrDefaultDCCableLengthMeters = (
  rawLength: unknown,
  attachObject?: DCCableLengthAttachObject
): number => {
  const parsed = Number(rawLength)
  if (Number.isFinite(parsed) && parsed > 0) return parsed
  return getDefaultDCCableLengthMeters(attachObject)
}
